import React, { useState, useRef, useCallback } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import * as S from './Navigation.styled';
import { CLUB_INFO } from '@utils/constants.js';
import { analytics } from '@utils/analytics.js';
import LogoIcon from '../../assets/image/logo-text.png';
import LogoIconCompact from '../../assets/image/logo.png';
import { VkIcon, TelegramIcon, YandexMapsIcon, PhoneIcon, ArrowIcon, MaxIcon } from '../Icons';

const Navigation = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isAboutDropdownOpen, setIsAboutDropdownOpen] = useState(false);
  const timeoutRef = useRef(null);
  const navigate = useNavigate();

  const handleDropdownMouseEnter = useCallback(() => {
    if (window.innerWidth > 768) {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
      setIsAboutDropdownOpen(true);
    }
  }, []);

  const handleDropdownMouseLeave = useCallback(() => {
    if (window.innerWidth > 768) {
      timeoutRef.current = setTimeout(() => {
        setIsAboutDropdownOpen(false);
      }, 300);
    }
  }, []);

  const handleNavigation = useCallback((path, name) => {
    analytics.trackEvent('Navigation', 'click', name);
    navigate(path);
    setIsMenuOpen(false);
    setIsAboutDropdownOpen(false);
  }, [navigate]);

  const handleAboutClick = useCallback((e) => {
    e.preventDefault();
    handleNavigation('/about', 'О клубе');
  }, [handleNavigation]);

  const toggleDropdown = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsAboutDropdownOpen(!isAboutDropdownOpen);
  }, [isAboutDropdownOpen]);

  const handleSocialClick = (platform, url) => {
    analytics.trackSocialClick(platform);
    window.open(url, '_blank');
  };

  const handlePhoneClick = () => {
    analytics.trackPhoneClick();
    // Используем номер с + для максимальной совместимости с iOS и Android
    window.location.href = `tel:${CLUB_INFO.phone}`;
  };

  return (
    <S.Navigation>
      <div className="container">
        <Link to="/" className="nav-logo" onClick={() => handleNavigation('/', 'Главная')}>
          <picture>
            <source media="(max-width: 449px)" srcSet={LogoIconCompact} />
            <img src={LogoIcon} alt="Князево Club" className="logo-image" />
          </picture>
        </Link>
        
        <S.NavMenu $isOpen={isMenuOpen}>
          <li className="nav-menu-item">
            <button onClick={() => handleNavigation('/', 'Главная')}>Главная</button>
          </li>

          <li 
            className="nav-menu-item dropdown" 
            onMouseEnter={handleDropdownMouseEnter} 
            onMouseLeave={handleDropdownMouseLeave}
          >
            <div className="dropdown-wrapper">
              <button onClick={handleAboutClick} className="dropdown-link">О клубе</button>
              <button className="dropdown-arrow" onClick={toggleDropdown} aria-label="Открыть меню">
                <ArrowIcon size={14} />
              </button>
            </div>
            <div className={`dropdown-menu ${isAboutDropdownOpen ? 'show' : ''}`}>
              <button className="dropdown-item" onClick={() => handleNavigation('/coaches', 'Тренерский состав')}>
                Тренерский состав
              </button>
{/*               <button className="dropdown-item" onClick={() => handleNavigation('/summer-camp', 'Летний детский лагерь')}>
                Летний детский лагерь
              </button> */}
              <button className="dropdown-item" onClick={() => handleNavigation('/certificates', 'Подарочные сертификаты')}>
                Подарочные сертификаты
              </button>
              <button className="dropdown-item" onClick={() => handleNavigation('/offer', 'Договор оферты')}>
                Договор оферты
              </button>
              <button className="dropdown-item" onClick={() => handleNavigation('/news', 'Акции и новости')}>
                Акции и новости
              </button>
            </div>
          </li>

          <li className="nav-menu-item">
            <button onClick={() => handleNavigation('/prices', 'Цены')}>Цены</button>
          </li>
          <li className="nav-menu-item">
            <button onClick={() => handleNavigation('/schedule', 'Расписание и запись')}>Расписание и запись</button>
          </li>
          <li className="nav-menu-item">
            <button onClick={() => handleNavigation('/gallery', 'Фотогалерея')}>Фотогалерея</button>
          </li>
          <li className="nav-menu-item">
            <button onClick={() => handleNavigation('/catalog', 'Каталог товаров')}>Каталог товаров</button>
          </li>
        </S.NavMenu>

        <div className="nav-actions">
          <div className="social-icons">
            <button 
              onClick={() => handleSocialClick('vk', CLUB_INFO.social.vk)} 
              className="social-icon-link vk" 
              aria-label="ВКонтакте"
            >
              <VkIcon size={16} />
            </button>
            <button 
              onClick={() => handleSocialClick('telegram', CLUB_INFO.social.telegram)} 
              className="social-icon-link telegram" 
              aria-label="Telegram"
            >
              <TelegramIcon size={16} />
            </button>
            <button
              onClick={() => handleSocialClick('max', CLUB_INFO.social.max)}
              className="social-icon-link max"
              aria-label="MAX"
            >
              <MaxIcon size={16} />
            </button>
            <button 
              onClick={() => handleSocialClick('yandex-maps', CLUB_INFO.maps.yandex)} 
              className="social-icon-link yandex-maps" 
              aria-label="Яндекс Карты"
            >
              <YandexMapsIcon size={20} />
            </button>
          </div>
          <button className="phone-link" onClick={handlePhoneClick}>
            <PhoneIcon size={14} /> {CLUB_INFO.phoneDisplay || '+7 (921) 933-44-40'}
          </button>
        </div>

        <button className="nav-toggle" onClick={() => setIsMenuOpen(!isMenuOpen)} aria-label="Меню">
          ☰
        </button>
      </div>
    </S.Navigation>
  );
};

export default Navigation;